import React from 'react';
import { Box, Typography, Card, CardMedia, IconButton, styled, useTheme, useMediaQuery } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

import FoodBurgerImage from '../../Assets/images/food-burger.jpg'; // Replace with your actual image path

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 600, // Adjust as needed
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  position: 'relative',
  margin: '0 auto', // Center the card
}));

const ImageTextOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  left: theme.spacing(2),
  color: theme.palette.common.white,
  padding: theme.spacing(1),
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  borderRadius: theme.shape.borderRadius,
}));

const LikeButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  color: theme.palette.common.white,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  borderRadius: '50%',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
}));

const ImageCarouselDots = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  left: theme.spacing(2),
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
}));

const CarouselDot = styled('div')(({ theme, active }) => ({
  width: theme.spacing(1),
  height: theme.spacing(1),
  borderRadius: '50%',
  backgroundColor: active ? theme.palette.primary.main : theme.palette.grey[300],
  cursor: 'pointer',
}));

const LikeCount = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  color: theme.palette.common.white,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0.5),
  fontSize: theme.typography.caption.fontSize,
}));

const ResponsiveFoodPost = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentDot, setCurrentDot] = React.useState(0); // For carousel dots (if you implement more images)
  const likeCount = '1.2k'; // Static like count from the image

  // If you had multiple images for a carousel
  const carouselDots = Array.from({ length: 5 }); // Example number of dots

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mt: 2 }}>
      <StyledCard>
        <CardMedia
          component="img"
          alt="Food Burger"
          height={isMobile ? '200' : '350'} // Adjust height for responsiveness
          image={FoodBurgerImage}
        />
        <ImageTextOverlay>
          <Typography variant="body2">Wisdom from a food junkie</Typography>
        </ImageTextOverlay>
        {carouselDots.length > 1 && (
          <ImageCarouselDots>
            {carouselDots.map((_, index) => (
              <CarouselDot
                key={index}
                active={index === currentDot}
                onClick={() => setCurrentDot(index)}
              />
            ))}
          </ImageCarouselDots>
        )}
        <LikeCount>{likeCount}</LikeCount>
        <LikeButton aria-label="like">
          <FavoriteBorderIcon />
        </LikeButton>
      </StyledCard>
    </Box>
  );
};

export default ResponsiveFoodPost;